import { GlobalAppState } from '@state/store';
import { createSelector } from 'reselect';
import { DealFinderResultsState } from '@model/state/deal-finder-results-state';
import { FiltersAdapter } from '@model/iceberg/filters/deal-finder/filters-adapter';

export const getDealFinderResults = (state: GlobalAppState) => state.dealFinderResults;
export const getDealFinderResultsData = (state: GlobalAppState) => state.dealFinderResults.data;
export const getDealFinderResultsToken = (state: GlobalAppState) => state.dealFinderResults.data.searchToken;
export const getDealFinderResultsFilters = (state: GlobalAppState) => state.dealFinderResults.data.facets.filters;
export const getDealFinderIsLoading = (state: GlobalAppState) => state.dealFinderResults.loading;
export const getDealFinderHasError = (state: GlobalAppState) => state.dealFinderResults.error;

export const getDealFinderHasResults = createSelector(getDealFinderResults, (state: DealFinderResultsState) => {
  const results = state?.data?.results ?? [];
  return !!results.length && !state.error && !state.loading;
});

export const getHasAppliedFilters = (state: GlobalAppState) => {
  const results = state.dealFinderResults.data.results;
  return (
    !(results && results.length) || FiltersAdapter.hasAppliedFilters(state.dealFinderResults.data?.facets.filters || [])
  );
};
